module.exports = __webpack_public_path__ + "static/img/index-bg.6f4954ce.png";